// extracted by mini-css-extract-plugin
module.exports = {"form":"TruckForm_form__3naiK"};